import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isModuleView } from './isModuleView';
import { rememberModulePage } from './lastModulePage';

/**
 * Запам'ятовує поточне «подання модуля» (isModuleView) як сторінку, до якої повертає крихта модуля й «← Модуль» (routes.moduleReturn):
 * прототип v4 page:'module' показує модуль у тому самому поданні й пункті меню.
 */
export function useModulePageMemory(ws: string, moduleKey: string, mainKey: string | undefined): void {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (mainKey && isModuleView(pathname, moduleKey, mainKey)) rememberModulePage(ws, moduleKey, `${pathname}${search}`);
  }, [ws, moduleKey, mainKey, pathname, search]);
}
